const styleSheet = () => ({
  container: {
    position: 'relative',
  },
  pillContainerHorizontal: {
    width: 'max-content',
    marginRight: '11px',
  },
  pillDividerVertical: {
    marginBottom: '6px',
  },
  attributeText: {
    height: '19px',
    width: '51px',
    color: '#000000',
    fontFamily: "'Museo Sans', sans-serif",
    fontWeight: 300,
    fontSize: '14px',
    fontHeight: '500',
    letterSpacing: 0,
    lineHeight: '19px',
  },
  pillDescriptionTitle: {
    marginBottom: '16px',
  },
  pillDescriptionContainer: {
    marginBottom: '16px',
  },
  strongText: {
    fontFamily: "'Museo Sans', sans-serif",
    fontWeight: 700,
  },
});

export default styleSheet;
